export default __webpack_public_path__ + "static/media/infralight-logo.1e6fa5de.png";